import {
    Paper,
    Table,
    Button,
    LinearProgress,
    InputLabel,
    FormControl,
    Select,
    MenuItem,
    Switch,
    FormGroup,
    Typography,
    TableRow,
    TableHead,
    TableCell,
    Dialog,
  } from "@material-ui/core";
  import Stack from '@mui/material/Stack';
  import GetRole from "./user";
  import { makeStyles } from "@material-ui/core/styles";
  import { fetchTokenData, fetchflightconfbooking, fetchflightallbooking, updateflightdata, fetchdetails, fetchToken, updateTokenData, releasepnr, getcpafterflightbooking, cancelflight, requeststatus} from "../api/customerapi";
  import { useEffect } from "react";
  import useState from 'react-usestateref'
  import { DateCalc2} from "./date.js";
  import DateCalc from "./date.js";


  const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8",
    },
    formgroup: {
      justifyContent: "center",
    },
    texttypo2: {
      marginTop: 0,
      color: "#a8020b",
      verticalAlign: "middle",
      //font:"Helvetica",
    },
  
    headertext: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      marginLeft: theme.spacing(3),
    },
    button: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: theme.spacing(14),
      height: theme.spacing(3),
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(1),
      fontSize: 10,
      verticalAlign: "middle",
    },
    button2: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: theme.spacing(10),
      height: theme.spacing(3),
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      fontSize: 10,
      verticalAlign: "middle",
    },
    textField: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      width: theme.spacing(20),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      textAlign: "left",
    },
  }));


const TBOView = () => {
    const classes = useStyles();
    const [bookings, setbookings] = useState([]);
    const [bookings2, setbookings2] = useState([]);
    const [cpafterflightbooking, setcpafterflightbooking] = useState(false);
    const [detailsdata, setdetailsdata] = useState(false);
    const [releasepnrresp, setreleasepnrresp] = useState(false);
    const [changeresp, setchangeresp] = useState(false);
    const [token, settoken] = useState("");
    const [statusresp, setstatusresp] = useState(false);
    const [dialog1, setdialog1] = useState(false);
    const [dialog2, setdialog2] = useState(false);
    const [dialog3, setdialog3] = useState(false);
    const [dialog4, setdialog4] = useState(false);
    const [dialog5, setdialog5] = useState(false);
    const [bookingdetails2, setbookingdetails2] = useState(true);
    const [searchData, setsearchData] = useState({});

    useEffect(() => {
      getBookings();
      getToken()
    }, []);

    useEffect(() => {
      
      if(bookingdetails2){
        //console.log("ABC")
        getallBookings()
      }else{
        getBookings()
      }
      
    }, [bookingdetails2]);

    const getBookings=async()=>{
      const data=await fetchflightconfbooking()
      //console.log(data.data)
      setbookings(data.data)
      setbookings2(data.data)
    }

    const getallBookings=async()=>{
      //console.log("ABC")
      const data=await fetchflightallbooking()
      setbookings(data.data)
      setbookings2(data.data)
    }

    const getToken=async()=>{
        const data= await fetchTokenData();
        //console.log(data.data)
        settoken(data.data[0].token)
        const newDate=DateCalc(0)
        const saveddate=DateCalc2(data.data[0].date, 0)
        //const saveddate=2
        //console.log(data.data[0])
        if(newDate!==saveddate){
            console.log("Fetching token")
            const newtokendata={
              "ClientId": "tboprod",
              "UserName": "DELJ300",
              "Password": "@dminInd$987#", 
            }
            const data2 = await fetchToken(newtokendata);
            
            console.log(data2.data)
            settoken(data2.data.TokenId)
            const newtokendata2={
              token:data2.data.TokenId,
              date:new Date()
            }
            //console.log(newtokendata2)
            const updatetokenResponse= await updateTokenData(data.data[0]._id, newtokendata2);
            
            if(updatetokenResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
                console.log("Token Data Updated")
            }
            else{
                alert("Unable to refresh data");
                
            }
        }else{
            console.log("New token will be fetched after 24 hours")
        }
        
       }
  
    const cancelbooking=async(booking)=>{

      if(booking.bookingstatus=="Cancellation Requested"){
        setdialog5(true)
        const finalsearchData={
          "TokenId":token,
          "ChangeRequestId":changeresp.ChangeRequestId,
        }
        console.log(finalsearchData)

        const statusResponse=await requeststatus(finalsearchData)
            console.log(statusResponse.data)
            setstatusresp(statusResponse.data.Response)
            if(statusResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
              var newdata={}
                if(statusResponse.data.Response.ChangeRequestStatus==4){
                newdata={...booking, bookingstatus:"Cancelled"}
                const responsedata=await updateflightdata(newdata)
                if(responsedata.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
                    alert("Cancellation Requested. Booking updated successfully")
                    window.location.reload()
                }else{
                    alert("Cancellation Requested. Booking not updated")
                }
                }
                
                
            }
            else{
                alert("Unable to refresh currency data");
                
            }
      }else{
      let a=window.confirm("Are you sure you want to cancel?");
      if(a){
        if(booking.ticketed){
          setdialog4(true)
          let rem= prompt("Enter cancellation remark", "");
          const finalsearchData={
            "TokenId":token,
            "BookingId":booking.BookingId,
            "RequestType":1,
            "CancellationType":3,
            "Remarks":rem,
          }
            const releaseResponse=await cancelflight(finalsearchData)
            console.log(releaseResponse.data)
            setchangeresp(releaseResponse.data.Response)
            if(releaseResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
                var crid="TicketCRInfo" in releaseResponse.data.Response?releaseResponse.data.Response.TicketCRInfo[0].ChangeRequestId:releaseResponse.data.Response.ChangeRequestId
                const newdata={...booking, bookingstatus:"Cancellation Requested", changerequestid:crid}
                const responsedata=await updateflightdata(newdata)
                if(responsedata.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
                    alert("Cancellation Requested. Booking updated successfully")
                    
                }else{
                    alert("Cancellation Requested. Booking not updated")
                }
                
            }
            else{
                alert("Unable to refresh currency data");
                
            }
        }else{
          setdialog3(true)
          const finalsearchData={
            "TokenId":token,
            "BookingId":booking.BookingId,
            "Source":booking.source,
          }
          console.log(finalsearchData)
            const releaseResponse=await releasepnr(finalsearchData)
            console.log(releaseResponse.data)
            setreleasepnrresp(releaseResponse.data.Response)
            if(releaseResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
                
                const newdata={...booking, bookingstatus:"Cancelled"}
                const responsedata=await updateflightdata(newdata)
                if(responsedata.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
                    alert("PNR Released. Booking updated successfully")
                   
                }else{
                    alert("PNR Released. Booking not updated")
                }
                
            }
            else{
                alert("Unable to refresh data");
                
            }

        }
      }
    }
    }
  
    const bookingdetails=async(booking)=>{
      setdialog2(true)
      const finalsearchData={
        "TokenId":token,
        "BookingId":booking.BookingId
      }
      console.log(finalsearchData)
      const detailsResponse= await fetchdetails(finalsearchData);
        console.log(detailsResponse.data)
      if(detailsResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
          //console.log(detailsResponse.data)
          setdetailsdata(detailsResponse.data.Response)
          // setstatus("completed")
      }
      else{
          alert("Something went wrong. Contact support");
          window.location = ("/home");
      }
      
    }

    const getcpafterbooking = async(booking)=>{
      setcpafterflightbooking(false)
      setdialog1(true)
        const finalsearchData={
            "TokenId":token,
            "BookingId":booking.BookingId,
            "RequestType":1
          }
        console.log(finalsearchData)
        const getcpResponse=await getcpafterflightbooking(finalsearchData);
        if(getcpResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            console.log(getcpResponse.data)
            setcpafterflightbooking(getcpResponse.data.Response)
        }
        else{
            alert("Unable to fetch data");
            
        }

    }

    const handleClose2 = () => {
      setdialog2(false);
      //window.open("/hotelview")
    };

    const handleClose3 = () => {
      setdialog3(false);
      //window.open("/hotelview")
    };

    const handleClose4 = () => {
      setdialog4(false);
      //window.open("/hotelview")
    };

    const handleClose5 = () => {
      setdialog5(false);
      //window.open("/hotelview")
    };

    const handleClose1 = () => {
        setdialog1(false);
        //window.open("/hotelview")
      };

    const handleChange = () => {
      setbookingdetails2(!bookingdetails2)
    }

    const filterbooking=() => {
      const capture=bookings2
      if(searchData.bookingstatus){
        var temp=capture.filter(b=>b.bookingstatus==searchData.bookingstatus)
        setbookings(temp)
      }else{
        setbookings(capture)
      }
    }

    const getprice=(fare)=>{
      var x=
        ("BaseFare" in fare?fare.BaseFare:0)+
        ("Tax" in fare?fare.Tax:0)+
        ("OtherCharges" in fare?fare.OtherCharges:0)+
        ("ServiceFee" in fare?fare.ServiceFee:0)+
        ("AirlineTransFee" in fare?fare.AirlineTransFee:0)-
        ("PLBEarned" in fare?fare.PLBEarned:0)-
        ("CommissionEarned" in fare?fare.CommissionEarned:0)-
        ("IncentiveEarned" in fare?fare.IncentiveEarned:0)+
        ("TdsOnPLB" in fare?fare.TdsOnPLB:0)+
        ("TdsOnCommission" in fare?fare.TdsOnCommission:0)+
        ("TdsOnIncentive" in fare?fare.TdsOnIncentive:0)+
        ("GST" in fare?fare.GST:0)
      return Math.round(x)
    }

    const getclass=(value) =>{
      if(value==2){
        return "Economy"
      }else if(value==3){
        return "Premium Economy"
      }else if (value==4){
        return "Business"
      }else if (value==5){
        return "Premium Business"
      }else if (value==6){
        return "First"
      }
    }

    

    //console.log(changeresp)
    
    return (
      <div>
      <Dialog fullWidth maxWidth="m" open={dialog2} onClose={handleClose2}>
        {detailsdata?(
         <div>
         {detailsdata.ResponseStatus==1?(
          <div>
                
                  <Typography variant="h6" className={classes.red}>Price: INR {getprice(detailsdata.FlightItinerary.Fare)} ({detailsdata.FlightItinerary.ResultFareType})
                  </Typography>
                  {detailsdata.FlightItinerary.Segments.map(details => <div>
                    
                      <Typography variant="h6" className={classes.orange}>
                    Airline: {details.Airline.AirlineName} ({details.Airline.AirlineCode}-{details.Airline.FlightNumber}{details.Airline.FareClass}) || Class: {getclass(details.CabinClass)} || Baggage: {details.Baggage} || CabinBaggage: {"CabinBaggage" in details?details.CabinBaggage:""} 
                  </Typography>
                  <Typography variant="h6" className={classes.blue}>Origin: {details.Origin.Airport.CityName} ({details.Origin.Airport.AirportCode}) - Terminal {details.Origin.Airport.Terminal} || Departure: {new Date(details.Origin.DepTime).toLocaleString("en-IN")} </Typography> 
                  <Typography variant="h6" className={classes.blue}>Destination: {details.Destination.Airport.CityName} ({details.Destination.Airport.AirportCode}) - Terminal {details.Destination.Airport.Terminal} || Arrival: {new Date(details.Destination.ArrTime).toLocaleString("en-IN")}</Typography>
                  <Typography variant="h6" className={classes.brown}>Duration: {Math.floor(details.Duration/60)} hrs {details.Duration%60} mins || Seats Available: {details.NoOfSeatAvailable}</Typography>
                  <br></br>
                
               </div>)}
               <hr></hr>
                  {detailsdata.FlightItinerary.Passenger.map(p=>
                  <div>
                    <Typography variant="h6" className={classes.black}>Name: {p.FirstName} {p.LastName} || Birth Date: {p.DateOfBirth?p.DateOfBirth:""} || Passport: {p.PassportNo} </Typography>
                    {"Baggage" in p && p.Baggage.length>0?(<div>
                      {p.Baggage.map(b=><Typography variant="h6" className={classes.black}>{"Baggage: "+b.Weight}</Typography>)}
                    </div>):("")}
                    {"MealDynamic" in p && p.MealDynamic.length>0?(<div>
                      {p.MealDynamic.map(b=><Typography variant="h6" className={classes.black}>{"Meal: "+b.AirlineDescription+" X "+b.Quantity}</Typography>)}
                    </div>):("")}
                    <br></br>
                  </div>
                  )}
                  <Typography variant="h6" className={classes.black}>Last Ticket Date: {detailsdata.FlightItinerary.LastTicketDate}</Typography>
                  <Typography variant="h6" className={classes.black}>{"PenaltyCharges" in detailsdata.FlightItinerary?"CancellationCharge" in detailsdata.FlightItinerary.PenaltyCharges?"Cancellation Charges: "+detailsdata.FlightItinerary.PenaltyCharges.CancellationCharge:"":""} {"PenaltyCharges" in detailsdata.FlightItinerary?"ReissueCharge" in detailsdata.FlightItinerary.PenaltyCharges?"Reissue Charges: "+detailsdata.FlightItinerary.PenaltyCharges.ReissueCharge:"":""}</Typography>
                  <Typography variant="h6" className={classes.black}>Airline Code: {detailsdata.FlightItinerary.AirlineCode} || Remark: {detailsdata.FlightItinerary.AirlineRemark}</Typography>
                  </div>
         ):(
          <div>
          {detailsdata.Error.ErrorMessage}
          </div>
         )}
         </div>
        ):(
          <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>
        )}
      </Dialog>
      <Dialog fullWidth maxWidth="m" open={dialog1} onClose={handleClose1}>
        {cpafterflightbooking?(
         <div>
          {cpafterflightbooking.ResponseStatus==1?(
            <div>
                <p>Cancellation Charges: {cpafterflightbooking.Currency} {cpafterflightbooking.CancellationCharge}</p>
                <br></br>
                <p>Refund Amount: {cpafterflightbooking.Currency} {cpafterflightbooking.RefundAmount}</p>
                <br></br>
                <p>Remarks: {cpafterflightbooking.Remarks}</p>
            </div>
          ):(
          <div>
          {cpafterflightbooking.Error.ErrorMessage}
          </div>
          )}
         </div>
        ):(
          <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>
        )}
      </Dialog>
      <Dialog fullWidth maxWidth="m" open={dialog3} onClose={handleClose3}>
        {releasepnrresp ?(
         <div>
          {releasepnrresp.ResponseStatus==1?(
            <div>
            
            <p>Status: "Successfully released PNR"</p>
            <Button variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={()=>window.location.reload()}>Ok</Button>
           
            </div>
          ):(
          <div>
          {releasepnrresp.Error.ErrorMessage}
          </div>
          )}
         </div>
        ):(
          <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>
        )}
      </Dialog>
      <Dialog fullWidth maxWidth="m" open={dialog4} onClose={handleClose4}>
        {changeresp ?(
         <div>
          {changeresp.ResponseStatus==1?(
            <div>
            {"TicketCRInfo" in changeresp?(<div>
              {changeresp.TicketCRInfo.map(cr=>
              <div>
                <Typography>RequestId: {cr.ChangeRequestId}</Typography>
                <Typography>Status: {cr.Status} </Typography>
                <Typography>Remarks: {cr.Remarks}</Typography>
                </div>
              )}
            </div>):(<div>
              Request Id: {changeresp.ChangeRequestId}
            Status: {changeresp.Status} 
            Remarks: {changeresp.Remarks}
            </div>)}
            
            <Button variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={()=>window.location.reload()}>Ok</Button>
            </div>
          ):(
          <div>
          {changeresp.Error.ErrorMessage}
          </div>
          )}
         </div>
        ):(
          <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>
        )}
      </Dialog>
      <Dialog fullWidth maxWidth="m" open={dialog5} onClose={handleClose5}>
        {statusresp ?(
         <div>
          {statusresp.ResponseStatus==1?(
            <div>
            Request Id: {statusresp.ChangeRequestId}
            Status: {changeresp.ChangeRequestStatus} 
            Cancellation Charges: {changeresp.CancellationCharge}
            Refund: {changeresp.RefundedAmount}
            Service Tax: {changeresp.ServiceTaxOnRAF}
            </div>
          ):(
          <div>
          {statusresp.Error.ErrorMessage}
          </div>
          )}
         </div>
        ):(
          <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>
        )}
      </Dialog>

        <Paper id="myDIV" variant="outlined" className={classes.paper}>
        <Switch  onChange={handleChange} color="secondary" label="Search All/Confirmed"/>
        <div align="center">
            <Typography>Booked Flight List</Typography>
            {bookingdetails2?(
              <div>
              <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="status">Booking Status</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="status"
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                value={searchData.bookingstatus}
                onChange={(e) => setsearchData({...searchData, bookingstatus:e.target.value})}
              >
                <MenuItem value={"Failed"}>Failed</MenuItem>
                <MenuItem value={"Successful"}>Successful</MenuItem>
                <MenuItem value={"NotSaved"}>NotSaved</MenuItem>
                <MenuItem value={"Hold"}>Hold</MenuItem>
                <MenuItem value={"NotCreated"}>NotCreated</MenuItem>
                <MenuItem value={"NotAllowed"}>NotAllowed</MenuItem>
                <MenuItem value={"InProgress"}>InProgress</MenuItem>
                <MenuItem value={"TicketAlreadyCreated"}>TicketAlreadyCreated</MenuItem>
                <MenuItem value={"PriceChanged"}>PriceChanged</MenuItem>
                <MenuItem value={"OtherError"}>OtherError</MenuItem>
                <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
              </Select>
            </FormControl>
            <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>filterbooking()}
                    
                    className={classes.button}
                  >
                    Filter
            </Button>
              </div>
            ):("")}
            <Table>
            <TableHead>
                <TableCell>
                  Booking Date
                </TableCell>
                <TableCell>
                  PNR
                </TableCell>
                <TableCell>
                  Sector
                </TableCell>
                <TableCell>
                  Name
                </TableCell>
                <TableCell>
                  Date of Travel
                </TableCell>
                <TableCell>
                  Price
                </TableCell>
                <TableCell>
                  Ticket?
                </TableCell>
                <TableCell>
                  Status
                </TableCell>
                <TableCell>
                  Action Buttons
                </TableCell>
              </TableHead>
            {bookings.map(booking=>
             
              <TableRow>
                <TableCell>
                  {booking.bookingdate}
                </TableCell>
                <TableCell>
                  {booking.PNR}
                </TableCell>
                <TableCell>
                  {booking.origin} - {booking.destination}
                </TableCell>
                <TableCell>
                  {booking.pax}
                </TableCell>
                <TableCell>
                  {booking.traveldate?booking.traveldate.split("T").slice(0,1):""}
                </TableCell>
                <TableCell>
                  {booking.price}
                </TableCell>
                <TableCell>
                  {booking.ticketed?"True":"False"}
                </TableCell>
                <TableCell>
                  {booking.bookingstatus}
                </TableCell>
                <TableCell>
                <FormGroup row className={classes.formgroup}>
                {/* {booking.bookingstatus=="Hold"?(
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>ticketnonlcc(booking)}
                    
                    className={classes.button}
                  >
                    Ticket
            </Button>
                ):("")} */}
                
            <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>bookingdetails(booking)}
                    
                    className={classes.button}
                  >
                    Details
            </Button>
            <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>getcpafterbooking(booking)}
                    
                    className={classes.button}
                  >
                    Get CP
            </Button>
            <Button
                    variant="contained"
                    color="secondary"
                    onClick={()=>cancelbooking(booking)}
                    
                    className={classes.button}
                  >
                    {booking.bookingstatus=="Cancellation Requested"?"Get Status":"Cancel"}
            </Button>
                </FormGroup>
                
            </TableCell>
            
              </TableRow>
              
            )}
            </Table>
            
        </div>
        </Paper>
        </div>
)}

export default TBOView;